module.exports = __webpack_public_path__ + "static/media/locations.ac61677d.png";